import { useState } from 'react';
import './MailingListForm.css';

const ACCOUNT = '2308051';
const FORM_ID = '186262384972661801';
const ENDPOINT = `https://assets.mailerlite.com/jsonp/${ACCOUNT}/forms/${FORM_ID}/subscribe`;

export default function MailingListForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');

    try {
      const body = new URLSearchParams();
      body.append('fields[email]', email);
      body.append('ml_submit', '1');
      body.append('anticsrf', 'true');

      const res = await fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      const data = await res.json().catch(() => ({}));

      if (res.ok && data.success !== false) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <p className="mlf-success">You&rsquo;ve been added to the list &ndash; thank you.</p>
    );
  }

  return (
    <form className="mlf" onSubmit={handleSubmit} noValidate>
      <div className="mlf-row">
        <input
          type="email"
          className="mlf-input"
          placeholder="Your email address"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          disabled={status === 'loading'}
        />
        <button
          type="submit"
          className="mlf-btn"
          disabled={status === 'loading'}
        >
          {status === 'loading' ? 'Subscribing…' : 'Subscribe'}
        </button>
      </div>
      {status === 'error' && (
        <p className="mlf-error">Something went wrong – please try again.</p>
      )}
    </form>
  );
}
